export default "__VITE_ASSET__J4SDdUlN__"